import InfoIcon from "@mui/icons-material/Info";
import { Box, FormControlLabel, Radio, RadioGroup, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocaleContext } from "shared-ui/contexts/Locale/LocaleContext";
import { ChangeEvent, Dispatch } from "react";
import { MacroProtocolAction, MacroProtocolState } from "../reducer/macroProtocolReducer";
import AnthropometryTable from "./AnthropometryTable";

interface AnthropometryProps {
  state: MacroProtocolState;
  dispatch: Dispatch<MacroProtocolAction>;
}

const Anthropometry = ({ state, dispatch }: AnthropometryProps) => {
  const { t } = useTranslation();
  const { isMetricLocale } = useLocaleContext();
  const onSwitchAnthroType = (event: ChangeEvent<HTMLInputElement>) =>
    dispatch({
      type: "SWITCH_ANTHRO_TYPE",
      payload: event.target.value as "formFields" | "template",
      isMetricLocale,
    });
  const onSwitchUseExistingAnthro = (event: ChangeEvent<HTMLInputElement>) =>
    dispatch({
      type: "EDIT_USE_EXISTING_ANTHRO",
      payload: event.target.value === "true",
    });

  const useFormFields = state.anthropometry.__typename === "FormFields";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography>
          {t("mealPlanTemplate.macroProtocol.anthropometryForm.q1.label")}
          <Tooltip title={t("mealPlanTemplate.macroProtocol.anthropometryForm.q1.tooltip")}>
            <InfoIcon sx={{ pl: 1 }} />
          </Tooltip>
        </Typography>
        <RadioGroup
          sx={{ pt: 0, pl: 2 }}
          value={state.useExistingAnthropometry.toString()}
          onChange={onSwitchUseExistingAnthro}>
          <FormControlLabel
            value="true"
            control={<Radio />}
            label="Yes" />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="No" />
        </RadioGroup>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography>{t("mealPlanTemplate.macroProtocol.anthropometryForm.q2.label")}</Typography>
        <RadioGroup
          sx={{ pl: 2 }}
          value={useFormFields ? "formFields" : "template"}
          onChange={onSwitchAnthroType}>
          <FormControlLabel
            value="formFields"
            control={<Radio />}
            label={
              <Typography>
                {t("mealPlanTemplate.macroProtocol.anthropometryForm.q2.collectFromAthlete")}
                <Tooltip title={t("mealPlanTemplate.macroProtocol.anthropometryForm.q2.tooltip")}>
                  <InfoIcon sx={{ pl: 1 }} />
                </Tooltip>
              </Typography>
            }
          />
          <FormControlLabel
            value="template"
            control={<Radio />}
            label={t("mealPlanTemplate.macroProtocol.anthropometryForm.q2.assignDefaults")} />
        </RadioGroup>
      </Box>
      <Typography>
        {useFormFields
          ? t("mealPlanTemplate.macroProtocol.anthropometryForm.q3.label.fields")
          : t("mealPlanTemplate.macroProtocol.anthropometryForm.q3.label.values")}
      </Typography>
      <AnthropometryTable state={state.anthropometry} dispatch={dispatch} />
    </Box>
  );
};

export default Anthropometry;
